"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types");

function applyCompletions(model, completions, pathMapper, intercept, context) {
  var startUpdate = model.getCommandCount();
  var modifiedBatch;
  var errors;
  completions.forEach(function (c, idx) {
    var commandPath = c.command.path || [];
    var mapped = pathMapper.get(commandPath);
    var command = c.command;

    if (mapped != undefined) {
      var _a = c.command,
          path = _a.path,
          restOfCommand = __rest(_a, ["path"]);

      command = Object.assign({
        path: mapped
      }, restOfCommand);
    }

    commandPath = mapped || commandPath;
    var interception = intercept ? intercept(model.getDocument(), command, context) : undefined;
    var isModified = mapped != undefined || interception != undefined;
    var resultWithCommand = applyCommandWithInterception(model, command, interception, c.createdId);
    var result = resultWithCommand.result;

    if (resultWithCommand.modifiedCommand) {
      command = resultWithCommand.modifiedCommand;
    }

    if (result.isSuccess === true) {
      if (result.createdId != undefined && c.createdId != undefined && result.createdId !== c.createdId) {
        isModified = true;
        pathMapper.put(commandPath.concat(c.createdId), commandPath.concat(result.createdId));
      }

      if (modifiedBatch != undefined || isModified) {
        modifiedBatch = modifiedBatch || completions.slice(0, idx);
        var appliedCompletion = {
          command: command,
          createdId: result.createdId
        };
        modifiedBatch.push(appliedCompletion);
      }
    } else {
      modifiedBatch = modifiedBatch || completions.slice(0, idx);

      if (errors == undefined) {
        errors = [];
      }

      errors.push({
        action: c.command.action,
        path: commandPath,
        errorMessage: result.error
      });
    }
  });

  if (modifiedBatch) {
    return {
      applied: {
        from: startUpdate,
        completions: modifiedBatch
      },
      errors: errors
    };
  } else {
    return undefined;
  }
}

exports.applyCompletions = applyCompletions;

function applyCommandWithInterception(model, command, interception, proposedCreateId) {
  if (interception == undefined) {
    return {
      result: model.apply(command, proposedCreateId)
    };
  } else if (command.action !== types_1.CommandAction.Delete && interception.newProps != undefined) {
    var c;

    if (command.action === types_1.CommandAction.Create) {
      c = {
        path: command.path,
        action: command.action,
        props: interception.newProps
      };
    } else {
      c = {
        path: command.path,
        action: command.action,
        props: interception.newProps
      };
    }

    return {
      result: model.apply(c, proposedCreateId),
      modifiedCommand: c
    };
  }

  return {
    result: {
      isSuccess: false,
      error: interception.rejection
    }
  };
}

exports.applyCommandWithInterception = applyCommandWithInterception;